export default __webpack_public_path__ + "static/media/home8.67908a3d.jpg";